<template>
  <a class="p-m01-account-anchor">
    <slot></slot>
    <IconBase
      class="p-m01-account-anchor__icon"
      view-box="0 0 24 24"
      width="24"
      height="24"
    >
      <IconArrowRight />
    </IconBase>
  </a>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class M01AccountAnchor extends Vue {}
</script>

<style lang="scss" scoped>
.p-m01-account-anchor {
  position: relative;
  font-size: rem(14);
  padding: rem(18) rem(40) rem(19) rem(16);
  display: block;

  &__icon {
    color: $common-gray500;
    position: absolute;
    right: rem(8);
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
